import { webRoutes } from "./routes";

export const webConfig = {
  routes: webRoutes,
} as const;
